module.exports = __webpack_public_path__ + "img/wheelstart.954bc18d.png";